module.exports = __webpack_public_path__ + "static/img/import.089df7c1.png";